import api from "./api";

export const getScriptCoDetails = async (PatientGUID) => {
  if (!PatientGUID || !String(PatientGUID).trim()) {
    return null;
  }
  try {
    const response = await api.get(
      "/api/scriptco/customer/GetAllPatientListOfCustomer",
      {
        params: { PatientGUID },
      },
    );
    return response.data;
  } catch (error) {
    console.error("getScriptCoDetails failed:", error);
    return null;
  }
};

export const getScriptCoOrderHistory = async (payload = {}) => {
  try {
    const response = await api.post("/api/v1/scriptco/order/history", payload);
    return response.data;
  } catch (error) {
    console.error(
      "getScriptCoOrderHistory failed, returning fallback response:",
      error,
    );
    return null;
  }
};

export const createScriptCoCustomer = async (payload = {}) => {
  try {
    const response = await api.post(
      "/api/scriptco/customer/AddNewPatient",
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("createScriptCoCustomer failed:", error);
    const apiData = error?.response?.data;
    const msg =
      apiData?.message ||
      apiData?.error ||
      apiData?.statusMessage ||
      (typeof apiData === "string" ? apiData : null) ||
      error?.message ||
      null;
    return { error: true, success: false, message: msg };
  }
};

export const editScriptCoCustomer = async (payload = {}) => {
  try {
    const response = await api.patch(
      "/api/scriptco/customer/UpdatePatient",
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("editScriptCoCustomer failed:", error);
    const apiData = error?.response?.data;
    const msg =
      apiData?.message ||
      apiData?.error ||
      apiData?.statusMessage ||
      (typeof apiData === "string" ? apiData : null) ||
      error?.message ||
      null;
    return { error: true, success: false, message: msg };
  }
};

export const searchScriptCoProducts = async (payload = {}) => {
  try {
    const ndc =
      typeof payload === "string"
        ? payload
        : payload?.ndc || payload?.searchTerm || "";
    const response = await api.get("/api/scriptco/customer/GetAllProductList", {
      params: { ndc },
    });
    return response.data;
  } catch (error) {
    console.error("searchScriptCoProducts failed:", error);
    return null;
  }
};

export const createScriptCoOrder = async (memberProgramId, payload = {}) => {
  try {
    const response = await api.post(
      `/api/scriptco/customer/CustomerPlaceOrder/${memberProgramId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("createScriptCoOrder failed:", error);
    const apiData = error?.response?.data;
    const msg =
      apiData?.message ||
      apiData?.error ||
      apiData?.statusMessage ||
      (typeof apiData === "string" ? apiData : null) ||
      error?.message ||
      null;
    return { error: true, success: false, message: msg };
  }
};

export const getScriptCoOrderDetails = async (orderId) => {
  try {
    const response = await api.get("/api/scriptco/customer/GetOrderDetails", {
      params: { orderNumber: orderId },
    });
    return response.data;
  } catch (error) {
    console.error("getScriptCoOrderDetails failed:", error);
    const apiData = error?.response?.data;
    const msg =
      apiData?.message ||
      apiData?.error ||
      apiData?.statusMessage ||
      (typeof apiData === "string" ? apiData : null) ||
      error?.message ||
      null;
    return { error: true, success: false, message: msg };
  }
};

export const getScriptCoOrderStatus = getScriptCoOrderDetails;
export const getScriptCoTrackingDetail = getScriptCoOrderDetails;

export const addScriptCoOrderNote = async (orderId, payload = {}) => {
  try {
    const response = await api.post(
      `/api/v1/scriptco/order/notes/${orderId}/add`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("addScriptCoOrderNote failed:", error);
    return null;
  }
};
